import React from 'react';
import { connect } from 'react-redux'

import Master from '../../Components/Master';
import Dialog from '../../Components/Dialog';
import { TextFieldHelper, SelectFieldWrapperExtended } from '../../Components/Fields';
import { doPost } from '../../Redux/Actions'
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

const ENDPOINT = "users"

export const Fields = ({handleChange, mail, username, firstname, lastname, password, gruppe}) => (
    <Grid container spacing={8}>

        <SelectFieldWrapperExtended 
            n={4}
            items={[
                {val: "disponent", label: "Disponent"},
                {val: "zeiterfassung", label: "Zeiterfassung"},
                {val: "admin", label: "Administrator"},
            ]}
            name="Gruppe"
            value={gruppe ? gruppe : "admin"}
            handleChange={handleChange('gruppe')}
        />
        <TextFieldHelper n={8} value={username} onChange={handleChange('username')} label="Benutzername" />
                    
        <Grid item xs={12}><Divider /></Grid>
        <TextFieldHelper n={4} value={mail} onChange={handleChange('mail')} label="E-Mail" />
        <TextFieldHelper n={4} value={firstname} onChange={handleChange('firstname')} label="Vorname" />
        <TextFieldHelper n={4} value={lastname} onChange={handleChange('lastname')} label="Nachname" />

        <Grid item xs={12}><Divider /></Grid>
        <TextFieldHelper helper="Neues Passwort vergeben" n={4} value={password} onChange={handleChange('password')} label="Passwort wählen" />

    </Grid>
)

class NewEntry extends Master {

	state = {
		newEntry: {}
	}

	render() {

		var {
			handleClickOpen, dialogOpen
		} = this.props

        var {
        	newEntry
        } = this.state

		return (
			<Dialog
                title="Neuer Kontakt"
                saveAction={this.postData}
                closeAction={handleClickOpen}
                open={dialogOpen}
             >
				<Fields handleChange={this.handleChange} {...newEntry} />
			</Dialog>
		)
	}

}

const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doPost: (data) => dispatch(doPost(ENDPOINT, "api/generic/" + ENDPOINT, data)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewEntry);


// WEBPACK FOOTER //
// ./src/Routes/User/NewEntry.js